import "./TradingSystemsDialog.scss";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {TradingSystemsService} from "../service/TradingSystemsService";
import {PriceRangeFilter, TradingSystemsViewStore} from "../service/TradingSystemsViewStore";
import {IOnDestroy, IOnInit, IScope} from "angular";
import {ReplaySubject} from "rxjs";
import {ObjectUtil} from "../../js/util/ObjectUtil";
import {LocalStorageService} from "../../types/NgStorage";

export class TradingSystemsDialogController implements IOnInit, IOnDestroy {

    public viewStore: TradingSystemsViewStore;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);
    public priceRange: PriceRangeFilter;

    /** @ngInject */
    public constructor($localStorage: LocalStorageService,
                       tradingSystemsService: TradingSystemsService,
                       private $scope: IScope,
                       private $uibModalInstance: IModalInstanceService) {
        this.viewStore = new TradingSystemsViewStore(tradingSystemsService, $localStorage);

    }

    public $onInit(): void {
        this.viewStore
            .selected
            .takeUntil(this.destroyed$)
            .subscribe((selected) => this.$uibModalInstance.close(selected));

        this.viewStore
            .priceRangeFilter
            .takeUntil(this.destroyed$)
            .map((priceRangeFilter) => ObjectUtil.copy(priceRangeFilter))
            .subscribe((priceRangeFilter) => this.$scope.$applyAsync(() => this.priceRange = priceRangeFilter));
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
        this.viewStore.dispose();
    }

    public onPriceRangeUpdated(): void {
        this.viewStore.updatePriceRangeFilter(this.priceRange);
    }
}
